import baseKey from './_baseKey';

const ticketReportDomainKey = () => baseKey.domainKey('ticketReport');

/**
 * 작업 리포트 관련 쿼리키 제너레이터
 */
const ticketReportKey = {
  /**
   * @returns 작업 리포트 도메인 기본 쿼리키 (getter)
   * @example ['ticketReport']
   */
  domain() {
    return ticketReportDomainKey();
  },
  /**
   * @param ticketId 작업 티켓 ID
   * @returns 전체 작업 리포트 리스트 데이터 요청 쿼리키
   * @example ['ticketReport', 'list', 'all', 1]
   */
  listAllByTicketId(ticketId: number) {
    return [...baseKey.listKey(ticketReportDomainKey(), 'all'), ticketId];
  },
  /**
   * @param id 작업 리포트 ID
   * @returns 작업 리포트 상세 데이터 요청 쿼리키
   * @example ['ticketReport', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(ticketReportDomainKey(), 'detail'), id];
  },
};

export default Object.freeze(ticketReportKey);
